"use strict";

import { addBrowserClasses } from "./modules/_utils";
import "./modules/_nav";
import "./modules/scroll";
// import './aya-search';
import "./modules/_tabs";
import "./modules/accordionBasic";
import "./modules/accordionFAQ";

document.addEventListener("DOMContentLoaded", function () {
  document.getElementsByClassName("no-js")[0].classList.remove("no-js");

  // Common functions
  addBrowserClasses();

  // Import Javascript modules here:
  // example_module();

  // Get session storage value
  if (sessionStorage.getItem("referrerSite") === null) {
    var referrerSite = document.referrer;
    sessionStorage.setItem("referrerSite", referrerSite);
  }

  // Accordion
  const initAcc = (elem, option) => {
    document.addEventListener("click", function (e) {
      if (!e.target.matches(elem + " .acc-toggle")) return;
      else {
        if (!e.target.parentElement.classList.contains("active")) {
          if (option === true) {
            var elementList = document.querySelectorAll(
              elem + " .acc-container",
            );
            Array.prototype.forEach.call(elementList, function (e) {
              e.classList.remove("active");
            });
          }
          e.target.parentElement.classList.add("active");
        } else {
          e.target.parentElement.classList.remove("active");
        }
      }
    });
  };
  initAcc(".accordion", true);

  // Hubspot cookie settings links in footer
  const hubspotCookieSettings = document.getElementById(
    "hs-footer-cookie-settings",
  );
  if (hubspotCookieSettings) {
    hubspotCookieSettings.addEventListener("click", function (e) {
      e.preventDefault();
      var _hsp = (window._hsp = window._hsp || []);
      _hsp.push(["showBanner"]);
    });
  }

  // Get/set reddit, snap, cookie
  let params = new URLSearchParams(window.location.search);
  let rdtCid = params.get('rdt_cid');
  let scCid = params.get('ScCid');
  if (rdtCid) {
    let expires = new Date();
    expires.setDate(expires.getDate() + 14);
    document.cookie =
      'rdt_cid=' + encodeURIComponent(rdtCid) +
      '; expires=' + expires.toUTCString() +
      '; path=/; SameSite=Lax; Secure';
  }
  if (scCid) {
    let expires = new Date();
    expires.setDate(expires.getDate() + 14);
    document.cookie =
      'sn_cid=' + encodeURIComponent(scCid) +
      '; expires=' + expires.toUTCString() +
      '; path=/; SameSite=Lax; Secure';
  }
});
